/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AuditConfig } from './auditConfig';


export interface AuditConfigResponse { 
    audit_config?: AuditConfig;
    /**
     * user who modified audit config
     */
    modified_by?: string;
    modified_ts?: Date;
}

